<app-header [mobileOpen]="mobileMenuOpen" (notifyMobileOpen)="getMobileOpenNotification($event)"></app-header>

<div class="mainContainer">

    @if (!iAmVermittler) {
        <app-menu
            selectedItem="meine_daten"
            class="menu"
            [class.open]="mobileMenuOpen"></app-menu>
    } @else {
        @if (iAmSpy) {
            <app-menu
                selectedItem="kundendaten"
                class="menu"
                [class.open]="mobileMenuOpen"></app-menu>
        } @else {
            <app-menu
                selectedItem="x"
                class="menu"
                [class.open]="mobileMenuOpen"></app-menu>
        }
    }

    <div class="content" [class.closed]="mobileMenuOpen">
        <!-- BEGIN CONTENT -->

        @if ('profil' === category || (iAmVermittler && !iAmSpy)) {
            <div>
                @if (iAmSpy) {
                    <h1>Profil Mandant {{ hisName }}</h1>
                }
                @if (!iAmSpy) {
                    <h1>Mein Profil</h1>
                }
                @if (!iAmVermittler || iAmSpy) {
                    <basisdaten></basisdaten>
                }
                @if (!iAmSpy) {
                    <div>
                        <h2>
                            Meine Accountdaten
                            <div class="options" style="display: flex">
                                <button class="btn-white-orange" (click)="modify='modifyAccountDaten'">
                                    <span class="btn-ico-aenderung"></span> <span class="btn-text">Accountdaten ändern</span>
                                </button>
                                <button class="btn-white-orange" (click)="changePassword()">
                                    <span class="btn-ico-aenderung"></span> <span class="btn-text">Passwort ändern</span>
                                </button>
                            </div>
                        </h2>
                        @if (userData && userData.fullName && userData.email) {
                            <div class="gridContainer dataGrid">
                                <div class="row">
                                    <div class="cell grid-25">
                                        <span class="label">Benutzername</span>
                                        <span class="value">{{ userData.fullName.value }}</span>
                                    </div>
                                    <div class="cell grid-25">
                                        <span class="label">E-Mail-Adresse</span>
                                        <span class="value">{{ userData.email.value }}</span>
                                    </div>
                                    <div class="cell grid-50">
                                        <span class="label">Passwort</span>
                                        <span class="value">*****</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
                <!-- MODALS -->
                <!-- Modal Start -->
                @if (modify === 'modifyAccountDaten') {
                    <div id="accountdatenAendern" class="modal show">
                        <div class="modalTile">
                            <!-- Schliessen Button -->
                            <div class="closeMe" data-dismiss="modal" title="Schließen" (click)="cancelChange()"></div>
                            <!-- Ueberschrift -->
                            <div class="headline">
                                Accountdaten ändern
                            </div>
                            <div class="modalContent">
                                <div class="gridContainer formGrid fitGrid">
                                    <div class="row">
                                        <div class="cell grid-50"><!-- aka Benutzername; das ist der Name, der dem Kunden auch nach Login oben rechts angezeigt wird -->
                                            <label for="f_account_vorname"><strong>Vorname</strong></label>
                                            <input type="text"
                                                   id="f_account_vorname"
                                                   name="f_account_vorname"
                                                   maxlength="25"
                                                   value=""
                                                   placeholder="Vorname"
                                                   [readonly]="isChangeUserDataRequestRunning"
                                                   [(ngModel)]="userChangeModel.vorname.value"
                                                   [class.error]="userChangeModel.vorname.valid === false"
                                                   (blur)="validateField(userChangeModel.vorname)">
                                            @if (userChangeModel.vorname.valid === false) {
                                                <div
                                                    class="errorMessage"
                                                    [innerHTML]="userChangeModel.vorname.errorMsg"></div>
                                            }
                                        </div>
                                        <div class="cell grid-50">
                                            <label for="f_account_name"><strong>Name</strong></label>
                                            <input type="text"
                                                   id="f_account_name"
                                                   name="f_account_name"
                                                   maxlength="25"
                                                   value=""
                                                   placeholder="Name"
                                                   [readonly]="isChangeUserDataRequestRunning"
                                                   [(ngModel)]="userChangeModel.nachname.value"
                                                   [class.error]="userChangeModel.nachname.valid === false"
                                                   (blur)="validateField(userChangeModel.nachname)">
                                            @if (userChangeModel.nachname.valid === false) {
                                                <div
                                                    class="errorMessage"
                                                    [innerHTML]="userChangeModel.nachname.errorMsg"></div>
                                            }
                                        </div>
                                    </div>
                                    <div class="row trenner">
                                    </div>
                                    <div class="row">
                                        <div class="cell grid-50">
                                            <label for="f_account_email1"><strong>E-Mail-Adresse</strong></label>
                                            <input maxlength="79"
                                                   id="f_account_email1"
                                                   name="f_account_email1"
                                                   type="text"
                                                   value=""
                                                   placeholder="E-Mail-Adresse"
                                                   [readonly]="isChangeUserDataRequestRunning"
                                                   [(ngModel)]="userChangeModel.email.value"
                                                   [class.error]="userChangeModel.email.valid === false">
                                            @if (userChangeModel.email.valid === false) {
                                                <div
                                                    class="errorMessage"
                                                    [innerHTML]="userChangeModel.email.errorMsg"></div>
                                            }
                                        </div>
                                        <div class="cell grid-50">
                                            <label for="f_account_email2"><strong>E-Mail-Adresse wiederholen</strong></label>
                                            <input type="text"
                                                   id="f_account_email2"
                                                   name="f_account_email2"
                                                   maxlength="79"
                                                   value=""
                                                   placeholder="E-Mail-Adresse wiederholen"
                                                   [readonly]="isChangeUserDataRequestRunning"
                                                   [(ngModel)]="userChangeModel.emailConfirm.value"
                                                   [class.error]="userChangeModel.email.valid === false">
                                            @if (userChangeModel.emailConfirm.valid === false) {
                                                <div
                                                    class="errorMessage"
                                                    [innerHTML]="userChangeModel.email.errorMsg"></div>
                                            }
                                        </div>
                                        <div style="margin-top: 1rem">Bitte geben Sie aus Sicherheitsgründen bei Änderung der E-Mail-Adresse auch das aktuelle Passwort an.</div>
                                    </div>
                                    <div class="row trenner">
                                    </div>
                                    <div class="row">
                                        <div class="cell grid-50">
                                            <label for="f_account_passwort_alt"><strong>Aktuelles Passwort</strong></label>
                                            <input type="password"
                                                   id="f_account_passwort_alt"
                                                   name="f_account_passwort_alt"
                                                   maxlength="40"
                                                   value=""
                                                   placeholder="Aktuelles Passwort"
                                                   autocomplete="new-password"
                                                   [readonly]="isChangeUserDataRequestRunning"
                                                   [(ngModel)]="userChangeModel.passwordOld.value"
                                                   [class.error]="userChangeModel.passwordOld.valid === false"
                                                   (blur)="validateField(userChangeModel.passwordOld)">
                                            @if (userChangeModel.passwordOld.valid === false) {
                                                <div
                                                    class="errorMessage"
                                                    [innerHTML]="userChangeModel.passwordOld.errorMsg"></div>
                                            }
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="cell grid-50">
                                            <elem-button buttonRole="TERTIARY" class="expand" (click)="cancelChange()" [disabled]="isChangeUserDataRequestRunning">
                                                Abbrechen
                                            </elem-button>
                                        </div>
                                        <div class="cell grid-50">
                                            <elem-button buttonRole="PRIMARY" class="expand" (click)="changeUserData()" [disabled]="isChangeUserDataRequestRunning">
                                                Daten ändern
                                            </elem-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <!-- Modal Ende -->
            </div>
        }

        @switch (category) {
            @case ('jahresabschluss') {
                <div>
                    <app-jahresabschluss></app-jahresabschluss>
                </div>
            }
            @case ('maklermandat') {
                <kunden-maklermandat></kunden-maklermandat>
            }
            @case ('benutzerverwaltung') {
                <div>
                    <benutzerverwaltung></benutzerverwaltung>
                </div>
            }
        }


    </div>
</div>
